import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";

export const people = (props) => {
  return <PeopleAltRoundedIcon {...props} />;
};
